import React, { useState } from "react";
import "../requestcontract.css"
import { Dropdown } from 'primereact/dropdown';

const Contract = ({ handleStep }) => {
  const [selectedCity, setSelectedCity] = useState(null);
  const cities = [
    { name: 'Pending' },
    { name: 'Change Requested' },
    { name: 'Completed' },
  ];
  return (
    <>
      <div className="container-fluid">
        <div className="d-flex flex-wrap justify-content-between align-items-center">
          <div className="request-title">
            <span>Contracts</span>
          </div>
          <div className="d-flex flex-wrap mt-2 mt-lg-0">
            <div className="mr-3">
              <Dropdown
                value={selectedCity}
                onChange={(e) => setSelectedCity(e.value)}
                options={cities}
                optionLabel="name"
                placeholder="Status"
                className="status-dropdown"
              />
            </div>

            <button className="create-contract mt-2 mt-lg-0">
              <span className="">Create Contracts</span>
            </button>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-lg-6 col-md-6 col-sm-12">
            <div className="project-conatiner p-3">
              <div className="d-flex justify-content-between">
                <div className="project-title">
                  <span>Project Name</span>
                </div>
                <div className="status-update" onClick={handleStep}>
                  <span className="p-1">Pending</span>
                </div>
              </div>
              <div className="border-style mt-2 mb-2"></div>

              <div className="course-title">
                <span>Course Content</span>
              </div>
              <div className="d-flex justify-content-between mt-2 align-items-center">
                <div className="date">
                  <img src="/img/date.png" />
                  <span className="ml-1">06-12-2025</span>
                </div>
                <div className="total-count">
                  <span className="">Total Version: 0</span>
                </div>
              </div>
              <div className="d-flex justify-content-between mt-2 align-items-center">
                <div className="Creator">
                  <span className="ml-1">Creator : John Doe</span>
                </div>
                <button className="view-btn">
                  <span className="">View</span>
                </button>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12">
            <div className="project-conatiner p-3">
              <div className="d-flex justify-content-between">
                <div className="project-title">
                  <span>Project Name</span>
                </div>
                <div className="completed-requested">
                  <span className="p-1">Completed</span>
                </div>
              </div>
              <div className="border-style mt-2 mb-2"></div>

              <div className="course-title">
                <span>Course Content</span>
              </div>
              <div className="d-flex justify-content-between mt-2 align-items-center">
                <div className="date">
                  <img src="/img/date.png" />
                  <span className="ml-1">06-12-2025</span>
                </div>
                <div className="total-count">
                  <span className="">Total Version: 0</span>
                </div>
              </div>
              <div className="d-flex flex-wrap justify-content-between mt-2 align-items-center">
                <div className="Creator">
                  <span className="ml-1">Creator : John Doe</span>
                </div>
                <div className=" mt-2 mt-lg-0">
                  <button className="view-btn mr-2">
                    <span className="">View</span>
                  </button>
                  <button className="view-btn">
                    <span className="">Download</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 mt-2">
            <div className="project-conatiner p-3">
              <div className="d-flex justify-content-between">
                <div className="project-title">
                  <span>Project Name</span>
                </div>
                <div className="change-requested">
                  <span className="p-1">Change Requested</span>
                </div>
              </div>
              <div className="border-style mt-2 mb-2"></div>

              <div className="course-title">
                <span>Course Content</span>
              </div>
              <div className="d-flex justify-content-between mt-2 align-items-center">
                <div className="date">
                  <img src="/img/date.png" />
                  <span className="ml-1">06-12-2025</span>
                </div>
                <div className="total-count">
                  <span className="">Total Version: 0</span>
                </div>
              </div>
              <div className="d-flex justify-content-between mt-2 align-items-center">
                <div className="Creator">
                  <span className="ml-1">Creator : John Doe</span>
                </div>
                <button className="view-btn" onClick={handleStep}>
                  <span className="">View</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default Contract;